import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";

import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Conference from "@/pages/Conference";
import Agenda from "@/pages/Agenda";
import Speakers from "@/pages/Speakers";
import Expo from "@/pages/Expo";
import Attend from "@/pages/Attend";
import Venue from "@/pages/Venue";
import Sponsor from "@/pages/Sponsor";
import Exhibit from "@/pages/Exhibit";
import Awards from "@/pages/Awards";
import Calculator from "@/pages/Calculator";
import Insights from "@/pages/Insights";
import InsightArticle from "@/pages/InsightArticle";
import Register from "@/pages/Register";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import RefundPolicy from "@/pages/RefundPolicy";
import TopicPage from "@/pages/TopicPage";
import { TOPIC_SLUGS } from "@/data/topics";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import DelegatesPage from "@/pages/admin/DelegatesPage";
import AbandonedPage from "@/pages/admin/AbandonedPage";
import DownloadsPage from "@/pages/admin/DownloadsPage";
import LeadsInboxPage from "@/pages/admin/LeadsInboxPage";
import ExhibitorsPage from "@/pages/admin/ExhibitorsPage";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/conference" element={<Conference />} />
            <Route path="/conference/agenda" element={<Agenda />} />
            <Route path="/conference/speakers" element={<Speakers />} />
            <Route path="/expo" element={<Expo />} />
            <Route path="/attend" element={<Attend />} />
            <Route path="/venue" element={<Venue />} />
            <Route path="/sponsor" element={<Sponsor />} />
            <Route path="/exhibit" element={<Exhibit />} />
            <Route path="/awards" element={<Awards />} />
            <Route path="/ethanol-impact-calculator" element={<Calculator />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:slug" element={<InsightArticle />} />
            <Route path="/register" element={<Register />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            {TOPIC_SLUGS.map((s) => (
              <Route key={s} path={`/${s}`} element={<TopicPage />} />
            ))}
            <Route path="*" element={<NotFound />} />
          </Route>
          {/* Admin (no public Layout — dedicated Event OS shell) */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="delegates" element={<DelegatesPage />} />
            <Route path="abandoned" element={<AbandonedPage />} />
            <Route path="downloads" element={<DownloadsPage />} />
            <Route path="leads" element={<LeadsInboxPage />} />
            <Route path="exhibitors" element={<ExhibitorsPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      </HelmetProvider>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
